import {html, render} from 'uhtml';
import {BasePanel} from '../panel';

const Autodesk = window.Autodesk;

export class ModomSectionPlugin {
    PanelClass = BasePanel;

    name = null;

    label = null;

    icon = null;

    panelEl = null;

    constructor(manager) {
        this.manager = manager;
    }

    createPanelUI(viewer, container, otherPanelNames) {
        // Button to show the docking panel
        const toolbarButton = new Autodesk.Viewing.UI.Button(`${this.name}Button`);

        toolbarButton.onClick = () => {
            // If null, create it just once to avoid duplicated bindings
            if (this.manager.pluginPanels[this.name] == null) {
                const panelInstance = new this.PanelClass(
                    viewer,
                    container,
                    this.name,
                    this.label
                );
                this.panelEl = panelInstance.getRenderNode();
                this.renderTemplate();

                this.manager.pluginPanels[this.name] = panelInstance;

                this.manager.pluginPanels[this.name].addVisibilityListener(isVisible => {
                    // Reposition the panel on the toolbar side
                    this.manager.pluginPanels[this.name].container.style.top = '0px';
                    this.manager.pluginPanels[this.name].container.style.left = '120px';

                    // Show/hide panel button
                    // Always remove class first to avoid reversed states
                    toolbarButton.removeClass('is-selected');
                    if (isVisible) {
                        toolbarButton.addClass('is-selected');
                    }

                    // Hide other panels
                    for (const panelName of otherPanelNames) {
                        if (isVisible && this.manager.pluginPanels[panelName]) {
                            this.manager.pluginPanels[panelName].setVisible(false);
                        }
                    }
                });
            }

            // Show/hide docking panel
            this.manager.pluginPanels[this.name].toggleVisibility();
        };

        toolbarButton.icon.classList.add('modom-icon');
        toolbarButton.icon.style.backgroundImage = `url("${this.icon}")`;
        toolbarButton.setToolTip(this.label);

        return toolbarButton;
    }

    filterModelData(modelData) {
        return modelData;
    }

    getTemplate() {
        return html`
            <div class="panel-container">
                <div class="label movableArea wip-container">
                    WORK IN PROGRESS
                </div>
            </div>
        `;
    }

    renderTemplate() {
        if (this.panelEl) {
            const {options} = this.manager;
            const updateOptions = data => this.manager.updateOptions(data);
            render(this.panelEl, this.getTemplate(options, updateOptions));
        }
    }
}
